import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NoteDropdown from '../noteDropdown';

const SelectedMedicalHistories = ({ selectedData, setSelectedHistories }) => {
  const allNotes = useSelector((state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || []);
  const [medical, setMedical] = useState([]);

  useEffect(() => {
    setMedical([...(selectedData?.medical ?? [])]);
  }, [selectedData]);

  // const handleMedicalExtra = (index, fieldName, val) => {
  //   if (fieldName === 'present' || fieldName === 'absent') {
  //     selectedData.medical[index]['present'] = '';
  //     selectedData.medical[index]['absent'] = '';
  //   } else if (fieldName === 'unit' && val === 'long time') {
  //     selectedData.medical[index]['duration'] = '';
  //   }
  //   selectedData.medical[index][fieldName] = val;
  //   setSelectedHistories({ ...selectedData });
  // };

  const handleMedicalExtra = (item, fieldName, val) => {
    const medicalData = [...selectedData.medical];
    const objIndex = medicalData.findIndex((data) => data.name === item.name);

    if (objIndex !== -1) {
      const updatedItem = { ...medicalData[objIndex] };

      if (fieldName === 'present' || fieldName === 'absent') {
        updatedItem.present = '';
        updatedItem.absent = '';
      } else if (fieldName === 'unit' && val === 'long time') {
        updatedItem.duration = '';
      }

      updatedItem[fieldName] = val;
      medicalData[objIndex] = updatedItem;

      setSelectedHistories({
        ...selectedData,
        medical: medicalData,
      });
    }
  };

  const clearHistoryInput = (index) => {
    selectedData.medical[index].present = '';
    selectedData.medical[index].absent = '';
    setSelectedHistories({ ...selectedData });
  };

  const removeMedicalHistory = (item) => {
    setSelectedHistories({
      ...selectedData,
      medical: selectedData?.medical.filter((data) => data.name !== item.name),
    });
  };

  const selectedHistory = () => {
    const reverseSelectedData = [...medical].reverse();

    return reverseSelectedData?.map((item, index) => (
      <Row className="selected-item-row" key={index}>
        <Col md={2} className="font-weight-bold pr-0 pl-1">
          {item.name}
        </Col>

        <Col md={3} className="pr-0">
          <div className="input-group">
            <Form.Check
              type="radio"
              id={`present-${index}`}
              className="mr-2"
              label="Present"
              checked={item?.present === 'yes'}
              onChange={() => handleMedicalExtra(item, 'present', 'yes')}
            />
            <Form.Check
              type="radio"
              id={`absent-${index}`}
              label="Absent"
              checked={item?.absent === 'no'}
              onChange={() => handleMedicalExtra(item, 'absent', 'no')}
            />
          </div>
        </Col>

        <Col md={1} className="pl-0">
          <Button
            size="sm"
            variant={item?.present || item?.absent ? 'primary' : 'light'}
            onClick={() => clearHistoryInput(index)}
          >
            Clear
          </Button>
        </Col>

        <Col md={3} className="pl-0">
          <div className="input-group">
            <Form.Control
              size="sm"
              type="number"
              min="0"
              placeholder="Duration"
              value={item?.duration || ''}
              onChange={(e) =>
                handleMedicalExtra(item, 'duration', e.target.value)
              }
            />
            <Form.Select
              className="form-control form-control-sm"
              value={item?.unit || ''}
              onChange={(e) => handleMedicalExtra(item, 'unit', e.target.value)}
            >
              <option value="day(s)">Day(s)</option>
              <option value="week(s)">Week(s)</option>
              <option value="month(s)">Month(s)</option>
              <option value="year(s)">Year(s)</option>
              <option value="long time">Long Time</option>
            </Form.Select>
          </div>
        </Col>

        <Col md={2} className="pl-0 pr-0">
          <NoteDropdown
            value={item?.note || ''}
            onChange={(val) => handleMedicalExtra(item, 'note', val)}
            placeholder="Add Note"
            suggestions={allNotes.filter(
              (n) => n.elementType === 'history' && n.itemElement?.toLowerCase() === item.name?.toLowerCase(),
            )}
          />
        </Col>

        <Col className="">
          <i
            className="far fa-times-circle pt-1 cursor-pointer"
            aria-hidden="true"
            onClick={() => removeMedicalHistory(item)}
          ></i>
        </Col>
      </Row>
    ));
  };

  return <>{selectedHistory()}</>;
};

export default SelectedMedicalHistories;
